import LottieLoading from "@/components/ui/lottie-loading";

/**
 * Loading Fallback Component for Suspense Boundary
 */
export type PageLoadingProps = {
  description?: string;
};
function PageLoading({ description = "" }: PageLoadingProps) {
  return (
    <div className="min-h-screen flex items-center justify-center flex-col gap-2 bg-white">
      <LottieLoading size={70} />
      {description && (
        <p className="text-center font-medium text-sm text-gray-500">{description}</p>
      )}
    </div>
  );
}

export default PageLoading;
